<div class="logo-wrap" [ngClass]="{ 'd-none': isSidebar }">
  <app-logo></app-logo>
</div>
<div class="scrollable-container" [markScrolled]="FILTER" [ngClass]="{ 'left-menu-mode': !isSidebar, 'sidebar-mode': isSidebar }">
  <div class="filter-block" [ngClass]="{ 'filter-in-menu': !isSidebar, 'filter-fixed': isSidebar }">
    <div class="menu-filter" #FILTER>
      <app-search-field
        [caption]="'COMMON.SEARCH_IN_MENU'"
        [(searchQuery)]="_menuFilterInput"
        [filteredItems]="filteredMenuItems | keywordFilter: _menuFilterInput : 'label'"
        >
      </app-search-field>
    </div>
    @if (isSidebar) {
      <div class="sidebar-close">
        <i class="icon close-i" (click)="handleClose()"></i>
      </div>
    }
  </div>

  <!-- filtered menu items -->
  @if (_menuFilterInput) {
    <ul class="filtered-menu">
      @for (item of filteredMenuItems | keywordFilter: _menuFilterInput : 'label'; track item) {
        <li>
          <a routerLink="{{ item.href }}" routerLinkActive="active" (click)="handleClose()">
            {{ item.label }}
          </a>
        </li>
      }
    </ul>
  }

  <!-- not filtered menu items -->
  @if (!_menuFilterInput) {
    <div class="navigation-block">
      @for (group of menuSections | keyvalue; track group) {
        <div class="navigation-section">
          @if (+group.key > 0) {
            <h6 class="navigation-section-header">{{ getSectionName(group.key) | translate }}</h6>
          }
          @for (menuItem of group.value; track menuItem) {
            <div class="navigation-section-item" [ngClass]="{ active: menuItem.expanded }">
              @if (menuItem.menuDefinition.length > 0) {
                <a
                  tabindex="0"
                  class="navigation-section-item-link"
                  (click)="menuLinkHandler(menuItem)"
                  (keydown.enter)="menuLinkHandler(menuItem)"
                  [class.fit-content-width]="isSidebar"
                  >
                  <i class="icon {{ menuItem.icon }}"></i>
                  <span>{{ menuItem.header | translate }}</span>
                  <span class="icon dropdown-arrow"></span>
                  @if (menuItem.hasUnreadMessages && !menuItem.expanded) {
                    <div class="unread-messages"></div>
                  }
                  @if (menuItem.updates && !menuItem.expanded) {
                    <div class="updates">{{ menuItem.updates }}</div>
                  }
                </a>
              }
              @if (menuItem.menuDefinition.length === 0) {
                <a
                  [routerLinkActiveOptions]="{ exact: true }"
                  routerLinkActive="active"
                  [routerLink]="menuItem.routerLink"
                  class="navigation-section-item-link"
                  (click)="menuLinkHandler(menuItem)"
                  >
                  <i class="icon {{ menuItem.icon }}"></i>
                  <span>{{ menuItem.header | translate }}</span>
                  @if (menuItem.hasUnreadMessages) {
                    <div class="unread-messages"></div>
                  }
                  @if (menuItem.updates) {
                    <div class="updates">{{ menuItem.updates }}</div>
                  }
                </a>
              }
              <ul [@expandCollapse]="menuItem.expanded ? 'expanded' : 'collapsed'">
                @for (definition of menuItem.menuDefinition; track definition; let i = $index) {
                  <li>
                    <a
                      [attr.tabindex]="menuItem.expanded ? 0 : -1"
                      routerLink="{{ definition.href }}"
                      routerLinkActive="active"
                      (click)="handleClose()"
                      >
                      {{ definition.caption | translate }}
                    </a>
                    <div class="navigation-item-notifications">
                      @if (menuItem.hasUnreadMessages) {
                        <div class="unread-messages"></div>
                      }
                      @if (menuItem.updates) {
                        <div class="updates">{{ menuItem.updates }}</div>
                      }
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
      @if (isSidebar) {
        <div class="help-block">
          <a routerLink="/dh/help" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active" (click)="handleClose()">
            <i class="icon help-i"></i>
            <span>{{ 'HELP_TEXT' | translate }}</span>
          </a>
        </div>
      }
    </div>
  }
</div>
